import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkStylePipeModule, MetaUrlModule, ParamsTranslateModule, PopupIndicatorPipeModule } from '@lib/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { LinkLabelComponent } from './link-label.component';

@NgModule({
  declarations: [LinkLabelComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ParamsTranslateModule,
    PopupIndicatorPipeModule,
    MetaUrlModule,
    LinkStylePipeModule,
  ],
  exports: [LinkLabelComponent],
})
export class LinkLabelModule {}